import { render, staticRenderFns } from "./PageWelcome.vue?vue&type=template&id=2f2e1045&scoped=true&"
import script from "./PageWelcome.vue?vue&type=script&lang=ts&"
export * from "./PageWelcome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e1045",
  null
  
)

export default component.exports